// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SwitchMapButton_wrapper__-qE0g","text":"SwitchMapButton_text__1chZU"};